"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var math_1 = require("../../helpers/math");
var array_1 = require("../../helpers/array");
var date_1 = require("../../helpers/date");
var UserModel = /** @class */ (function (_super) {
    __extends(UserModel, _super);
    function UserModel(user, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = user.id;
        _this.descomplicaId = user.descomplicaId;
        _this.email = user.email;
        _this.role = user.role;
        _this.name = user.name;
        _this.firstName = user.firstName;
        _this.lastName = user.lastName;
        _this.picture = user.picture;
        _this.pictureSHA = user.pictureSHA;
        _this.isStaffMember = user.isStaffMember;
        _this.contractsByUserId = user.contractsByUserId || [];
        _this.enrollmentsByUserId = user.enrollmentsByUserId || [];
        _this.startedEnrollments = user.startedEnrollments || [];
        _this.pearsonKey = user.pearsonKey;
        _this.phone = user.phone;
        _this.phoneConfirmationDate = date_1.translateStringToDate(user.phoneConfirmationDate);
        _this.chimeraInfo = user.chimeraInfo;
        return _this;
    }
    Object.defineProperty(UserModel.prototype, "fullName", {
        get: function () {
            var _a;
            if (((_a = this.chimeraInfo) === null || _a === void 0 ? void 0 : _a.firstName) && this.chimeraInfo.firstName !== 'Aluno') {
                if (this.chimeraInfo.lastName) {
                    return this.chimeraInfo.firstName + " " + this.chimeraInfo.lastName;
                }
                else {
                    return this.chimeraInfo.firstName;
                }
            }
            else {
                return this.name;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "contracts", {
        get: function () {
            var _this = this;
            return this.contractsByUserId.map(function (contractId) { return _this.getters.contractById(contractId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "degrees", {
        get: function () {
            var degrees = this.getters.allDegrees() || [];
            var contracts = this.contracts;
            return degrees.filter(function (degree) {
                return contracts.find(function (contract) { return contract.courseByCourseId === degree.courseId; });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "enrollments", {
        get: function () {
            var _this = this;
            if (this.getters.startedEnrollmentsByUserId) {
                return this.getters.startedEnrollmentsByUserId(this.id);
            }
            return this.enrollmentsByUserId.map(function (enrollmentId) { return _this.getters.enrollmentById(enrollmentId); });
        },
        enumerable: false,
        configurable: true
    });
    UserModel.prototype.getEnrollmentsByCourseId = function (courseId) {
        var startedEnrollments = this.getStartedEnrollments();
        var enrollments = startedEnrollments && startedEnrollments.length ? startedEnrollments : this.enrollments;
        return enrollments.filter(function (e) { return e.classroom.courseId === courseId; });
    };
    Object.defineProperty(UserModel.prototype, "classrooms", {
        get: function () {
            if (this.getters.startedEnrollmentsByUserId) {
                var enrollments_1 = this.getters.startedEnrollmentsByUserId(this.id);
                if (enrollments_1)
                    return enrollments_1.map(function (enrollment) { return enrollment.classroom; });
            }
            var enrollments = this.enrollments ? this.enrollments.concat(this.getStartedEnrollments()) : [];
            return enrollments.map(function (enrollment) { return enrollment.classroom; });
        },
        enumerable: false,
        configurable: true
    });
    UserModel.prototype.getClassroomsByCourseId = function (courseId, shouldAddClassroomsWithCourseIdNull) {
        if (shouldAddClassroomsWithCourseIdNull === void 0) { shouldAddClassroomsWithCourseIdNull = false; }
        var enrollments = this.getEnrollmentsByCourseId(courseId);
        if (shouldAddClassroomsWithCourseIdNull) {
            var allEnrollments = enrollments.concat(this.getEnrollmentsByCourseId(null));
            return allEnrollments.map(function (enrollment) { return enrollment.classroom; });
        }
        return enrollments.map(function (enrollment) { return enrollment.classroom; });
    };
    Object.defineProperty(UserModel.prototype, "disciplines", {
        get: function () {
            return this.getters.disciplinesByUserId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "lists", {
        get: function () {
            return this.getters.listsByUserId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "schools", {
        get: function () {
            var _this = this;
            return __spread(new Set(this.lists.map(function (list) { return list.schoolId; }))).filter(function (schoolId) { return !!schoolId; })
                .map(function (schoolId) { return _this.getters.schoolById(schoolId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserModel.prototype, "managedClassrooms", {
        get: function () {
            return this.getters
                .staffsByUserId(this.id)
                .filter(function (s) { return s.classroomId && s.role.name === 'manager'; })
                .map(function (s) { return s.classroom; });
        },
        enumerable: false,
        configurable: true
    });
    UserModel.prototype.getStartedEnrollments = function () {
        var _this = this;
        if (this.getters.startedEnrollmentsByUserId) {
            return this.getters.startedEnrollmentsByUserId(this.id);
        }
        return this.startedEnrollments.map(function (enrollmentId) { return _this.getters.enrollmentById(enrollmentId); });
    };
    UserModel.prototype.getClassroomsProgress = function (classrooms) {
        if (classrooms === void 0) { classrooms = this.classrooms; }
        var progresses = classrooms.reduce(function (acc, classroom) {
            if (!classroom.isComplementary() && !classroom.isLeveling()) {
                return __spread(acc, [classroom.progress || 0]);
            }
            return acc;
        }, []);
        var total = array_1.arrayMean(progresses);
        return math_1.progressFormat(total);
    };
    UserModel.prototype.getKnowledgeProgress = function () {
        var knowledgesAbsoluteProgress = this.classrooms.reduce(function (acc, classroom) {
            if (classroom.progress === 100)
                acc.obtained += classroom.tags.length;
            acc.total += classroom.tags.length;
            return acc;
        }, { obtained: 0, total: 0 });
        return knowledgesAbsoluteProgress;
    };
    UserModel.prototype.getCourse = function (slug) {
        var contracts = this.contracts;
        if (!contracts || contracts.length === 0)
            return {};
        var course;
        if (slug)
            course = contracts.map(function (c) { return c.course; }).find(function (c) { return c.slug === slug; });
        else
            course = this.contracts[0].course;
        return __assign(__assign({}, course), { progress: this.getClassroomsProgress(course && course.classrooms), period: 1 });
    };
    UserModel.prototype.getAllCourses = function () {
        if (!this.contracts || this.contracts.length === 0)
            return undefined;
        return this.contracts.map(function (c) { return c.course; });
    };
    UserModel.prototype.getPhotoUrl = function () {
        // arg0 - size = 24
        // if (this.pictureSHA)
        //   return Passepartout.url(Passepartout.squareCrop(size), studentsPicturesBucket, this.pictureSHA);
        return '';
    };
    UserModel.prototype.isAdmin = function () {
        return this.role === 'admin';
    };
    Object.defineProperty(UserModel.prototype, "providerAssociations", {
        get: function () {
            return this.getters.providerAssociationsByUserId(this.id);
        },
        enumerable: false,
        configurable: true
    });
    return UserModel;
}(Model_1.default));
exports.UserModel = UserModel;
